import PeopleSocialMediaIcon from './PeopleSocialMediaIcon';

export { type PeopleSocialMediaIconProps } from './PeopleSocialMediaIcon';
export default PeopleSocialMediaIcon;
